import { apiClient } from './client'
import type {
  AttachFromGlobalMaterialRequest,
  AttachFromGlobalToolRequest,
  CatalogMaterial,
  CatalogTool,
  CreateCatalogMaterialRequest,
  CreateCatalogToolRequest,
  LinkCatalogMaterialRequest,
  LinkCatalogToolRequest,
  UpdateCatalogMaterialRequest,
  UpdateCatalogToolRequest,
} from './types'

export const createMaterial = async (
  projectId: string,
  data: CreateCatalogMaterialRequest
): Promise<CatalogMaterial> => {
  const response = await apiClient.post<CatalogMaterial>(
    `/api/v1/projects/${projectId}/catalog/materials`,
    data
  )
  return response.data
}

export const updateMaterial = async (
  id: string,
  data: UpdateCatalogMaterialRequest
): Promise<CatalogMaterial> => {
  const response = await apiClient.patch<CatalogMaterial>(`/api/v1/catalog/materials/${id}`, data)
  return response.data
}

export const deleteMaterial = async (id: string): Promise<void> => {
  await apiClient.delete(`/api/v1/catalog/materials/${id}`)
}

export const createTool = async (
  projectId: string,
  data: CreateCatalogToolRequest
): Promise<CatalogTool> => {
  const response = await apiClient.post<CatalogTool>(
    `/api/v1/projects/${projectId}/catalog/tools`,
    data
  )
  return response.data
}

export const updateTool = async (
  id: string,
  data: UpdateCatalogToolRequest
): Promise<CatalogTool> => {
  const response = await apiClient.patch<CatalogTool>(`/api/v1/catalog/tools/${id}`, data)
  return response.data
}

export const deleteTool = async (id: string): Promise<void> => {
  await apiClient.delete(`/api/v1/catalog/tools/${id}`)
}

// ---- Phase 15: global catalog binding -------------------------------------

export const attachFromGlobalMaterial = async (
  projectId: string,
  request: AttachFromGlobalMaterialRequest
): Promise<CatalogMaterial> => {
  const response = await apiClient.post<CatalogMaterial>(
    `/api/v1/projects/${projectId}/catalog/materials/from-global`,
    request
  )
  return response.data
}

export const attachFromGlobalTool = async (
  projectId: string,
  request: AttachFromGlobalToolRequest
): Promise<CatalogTool> => {
  const response = await apiClient.post<CatalogTool>(
    `/api/v1/projects/${projectId}/catalog/tools/from-global`,
    request
  )
  return response.data
}

export const linkCatalogMaterialToGlobal = async (
  projectId: string,
  materialId: string,
  request: LinkCatalogMaterialRequest
): Promise<CatalogMaterial> => {
  const response = await apiClient.patch<CatalogMaterial>(
    `/api/v1/projects/${projectId}/catalog/materials/${materialId}/link`,
    request
  )
  return response.data
}

export const linkCatalogToolToGlobal = async (
  projectId: string,
  toolId: string,
  request: LinkCatalogToolRequest
): Promise<CatalogTool> => {
  const response = await apiClient.patch<CatalogTool>(
    `/api/v1/projects/${projectId}/catalog/tools/${toolId}/link`,
    request
  )
  return response.data
}
